import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    textAlign: "right",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapeTopSection: {
    flexDirection: "row",
    width: "100%",
    height: "100%",
  },
  arrowIconCont: {
    color: "#FF0000",
    fontSize: "6px",
    alignItems: "space-between",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "16px",
    height: "15px",
    marginTop: "-7px",
  },
  landscapeArabTopSection3: {
    height: "474px",
    overflow: "hidden",
    width: "300px",
  },
  landscapeEngTopSection3: {
    height: "70%",
    width: "474px",
    transform: "rotate(90deg)",
    marginTop: "-5px",
    marginRight: "10px",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument5 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", marginRight: "6px" }}></View>
        <View style={{ width: "100%" }}>
          <View style={{ height: "474px", overflow: "hidden" }}>
            {arabicText(arabChunks[0])}
          </View>
        </View>
        <View
          style={{
            width: "40px",
            color: "#FF0000",
            marginLeft: "6px",
            alignItems: "flex-start",
          }}
        >
          <View style={{ fontSize: "6px", marginTop: "-13px" }}>
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "40px", marginRight: "6px" }}></View>
          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                { margin: "-30px 75px 0 0" },
              ]}
            >
              {engChunks[0]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View
            style={{
              width: "40px",
            }}
          >
            <View
              style={{
                fontSize: "6px",
                color: "#FF0000",
                marginLeft: "-35px",
              }}
            >
              <Text style={[Styles.pointingText, { marginTop: "-14px" }]}>
                Start of text
              </Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "right",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              marginRight: "6px",
            }}
          ></View>
          <View style={[Styles.landscapeTopSection]}>
            <View
              style={[Styles.landscapeArabTopSection3, { marginLeft: "30px" }]}
            >
              {arabicText(arabChunks[1])}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View style={Styles.arrowIconCont}>
              <Image
                src="/images/leftpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
              marginTop: "474px",
            }}
          >
            <Image
              src="/images/leftpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                { margin: "-30px 75px 0 0" },
              ]}
            >
              {engChunks[2]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View
              style={{
                fontSize: "6px",
                color: "#FF0000",
                width: "40px",
                marginLeft: "-35px",
              }}
            >
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              marginRight: "6px",
            }}
          >
            <Image
              src="/images/leftpdf_arrow.png"
              style={[
                Styles.arrowIcon,
                { marginLeft: "57px", marginTop: "473px" },
              ]}
            ></Image>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                { margin: "-0px 0px 0 0" },
              ]}
            >
              {engChunks[1]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View style={Styles.arrowIconCont}>
              <Image
                src="/images/leftcurvepdf_arrow.png"
                style={[Styles.curveArrowIcon, { alignSelf: "flex-start" }]}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "40px", marginRight: "6px" }}></View>
          <View style={[Styles.landscapeTopSection]}>
            <View style={Styles.landscapeArabTopSection3}>
              {arabicText(arabChunks[2])}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View
              style={{
                fontSize: "6px",
                color: "#FF0000",
                width: "40px",
                marginTop: "-10px",
                marginLeft: "-25px",
              }}
            >
              <Text style={Styles.pointingText}>نص مستأتف</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              fontSize: "6px",
              color: "#FF0000",
              marginRight: "6px",
            }}
          >
            <View
              style={{
                position: "absolute",
                top: "96%",
                width: "40px",
                marginLeft: "55px",
              }}
            >
              <Text style={Styles.pointingText}>End of text</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "center" }]}
              ></Image>
            </View>
          </View>
          <View style={[{ flexDirection: "row" }]}>
            <View style={Styles.landscapeEngTopSection3}>
              {engChunks[3]?.map((word, idx) => {
                return <Text key={idx}>{word}</Text>;
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View style={Styles.arrowIconCont}>
              <Image
                src="/images/leftpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", color: "#FF0000", marginRight: "6px" }}>
          <View style={{ fontSize: "6px", position: "absolute", top: "95%" }}>
            <Text style={Styles.pointingText}>نهاية النص</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "100%" }}>
          <View style={{ height: "474px", overflow: "hidden" }}>
            {arabicText(arabChunks[3])}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}></View>
      </Page>
    </Document>
  );
};

export default MyDocument5;
